/**
 * Product Selector
 */

import $ from 'jquery';
import Handlebars from 'handlebars';
// https://github.com/helpers/handlebars-helpers
// http://assemble.io/helpers/helpers-comparison.html
const helpers = require('handlebars-helpers')();
// const comparison = helpers.comparison();

// https://github.com/marioizquierdo/jquery.serializeJSON
require('jquery-serializejson');
// http://rangeslider.js.org/
require('rangeslider.js');
require('../plugins/jquery.fancybox.js');
// https://lodash.com/
const _ = require('lodash');
const ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
require('gsap/src/uncompressed/plugins/ScrollToPlugin.js');

import { showStickyMessage, hideStickyMessage } from './productSelectorMessage';
import tableWrapper from './tableWrapper';

// Elements
const $el = {
	optionsForm: $('.js-options-form'),
	productsForm: $('.js-products-form'),
	product: $('.js-product'),
	option: $('.js-option'),
	optionProduct: $('.js-option-product'),
	optionBroken: $('.js-option-broken'),
	optionRange: $('.js-rangeslider'),
	optionsGroup: $('.js-selector-options'),
	resultsButton: $('.js-results-button'),
	resultsHolder: $('.js-results-holder'),
	clearButton: $('.js-clear-button'),
	productsHolder: $('.js-selector-products'),
	productOption: $('.js-product-option'),
	productOptionAltHolder: $('.js-product-option-three-container'),
	control: $('.js-control'),
	relatedGroup: $('.js-selector-related'),
	relatedOptionGroup: $('.js-selector-related-option'),
	saveProducts: $('.js-save-products'),
	results: $('.js-selector-results'),
	nextRelatedButton: $('.js-next-related'),
	nextButton: $('.js-next'),
	skipButton: $('.js-skip'),
	editButton: $('.js-edit'),
	brokenContinueButton: $('.js-broken-continue'),
	editContinueButton: $('.js-edit-continue'),
	editCancelButton: $('.js-edit-cancel'),
	// Option Groups
	options: {
		Requirement: $('#requirement'),
		Type: $('#type'),
		Fuel: $('#fuel'),
		Usage: $('#usage'),
	},
	// Specific Products
	products: {
		LogicCombi: $('.js-product[data-boiler="logic-combi"]'),
		LogicPlusCombi: $('.js-product[data-boiler="logic-plus-combi"]'),
		LogicPlusHeat: $('.js-product[data-boiler="logic-plus-heat"]'),
		LogicPlusSystem: $('.js-product[data-boiler="logic-plus-system"]'),
		VogueCombi: $('.js-product[data-boiler="vogue-combi"]'),
		VogueSystem: $('.js-product[data-boiler="vogue-system"]'),
		LogicCombiEsp1: $('.js-product[data-boiler="logic-combi-esp1"]'),
		LogicCodeCombiEsp1: $(
			'.js-product[data-boiler="logic-code-combi-esp1"]',
		),
	},
	productOptions: {
		one: $('.js-product-option-one'),
		two: $('.js-product-option-two'),
		three: $('.js-product-option-three'),
	},
};

// Selected Options taken from local storage
let selected = {};
function setOptions(selectedOptions) {
	selected = {
		Requirement: _.get(selectedOptions, 'Requirement'),
		Type: _.get(selectedOptions, 'Type'),
		Fuel: _.get(selectedOptions, 'Fuel'),
		People: _.get(selectedOptions, 'People'),
		Bathrooms: _.get(selectedOptions, 'Bathrooms'),
		Boiler: _.get(selectedOptions, 'Boiler'),
		Control: _.get(selectedOptions, 'Control'),
	};
}

// Selected Products taken from local storage
let productsSelected = {};
function setProducts(selectedProducts) {
	productsSelected = {
		Boiler: _.get(selectedProducts, 'Boiler'),
		Controls: _.get(selectedProducts, 'Control'),
		Cylinder: _.get(selectedProducts, 'Cylinder'),
	};
}

// Selected Options
let selectedOption = {};
const OptionsJson = {};
const ProductsJson = {};

export default function init() {
	// setParams();
	rangeSlider();
	setState();
	bindEvents();

	setTimeout(() => {
		showStickyMessage();
	}, 5000);
}

function bindEvents() {
	$el.option.on('click', selectOption);
	$el.optionProduct.on('click', selectProduct);
	$el.optionRange.on('change', updateRange);
	$el.resultsButton.on('click', getResults);
	$el.product.on('click', selectBoiler);
	$el.nextRelatedButton.on('click', nextRelated);
	$el.saveProducts.on('click', saveProducts);
	$el.resultsHolder.on('click', '.js-edit', editButton);
	$el.brokenContinueButton.on('click', brokenModalContinue);
	$el.editCancelButton.on('click', editModalCancel);
	$el.editContinueButton.on('click', editModalContinue);
}

// Select the options
function selectOption(event) {
	const next = $(this).closest($el.optionsGroup).next($el.optionsGroup);
	// Check if we already have results
	// If we don't then select options as normal, if we have options move to editing state
	if (localStorage.getItem('options') === null) {
		// check if we are clicking the broken option
		if (
			$(this).hasClass('js-option-broken') &&
			!$(this).hasClass('js-modal-seen')
		) {
			brokenModal();
			event.preventDefault();
		} else if (next.length) {
			// Show the next set of options
			next.show();
			scrollToSections(next);
		}
	} else {
		edit();
		event.preventDefault();
		selectedOption = $(this);
	}
}

// Select products
function selectProduct() {
	const next = $(this).closest($el.optionsGroup).next($el.optionsGroup);
	// Show the next set of options
	if (next.length) {
		next.show();
		scrollToSections(next);
	}
}

function brokenModal() {
	$.fancybox.open({
		src: '#broken-content',
		opts: {
			afterClose() {
				if ($el.optionBroken.is(':checked')) {
					// show and scroll to types
					$el.options.Type.show();
					scrollToSections($el.options.Type);
					// adding class once we have seen modal
					$el.optionBroken.addClass('js-modal-seen');
				}
			},
		},
	});
}

function brokenModalContinue() {
	// select option
	$el.optionBroken.prop('checked', true);
	// close modal
	$.fancybox.close();
}

// Sets the state of the page based selected items in local storage
function setState() {
	// Load the Options from Local Storage
	if (localStorage.getItem('options') != null) {
		OptionsJson.loadOptions(JSON.parse(localStorage.options));
		// Update set options
		setOptions(JSON.parse(localStorage.options));
	}

	// Hide all option groups apart from the first on initial load
	$el.optionsGroup.not(':eq(0)').hide();

	// Show options groups with selected options
	$el.optionsGroup.each(function() {
		if ($(this).prev().find('input:checked').length > 0) {
			$(this).show();
		}
	});

	hideProducts();
	hideRelated();
	hideResults();
	showProducts();
	$el.nextButton.hide();
	nextSkip();
	matchHeights();
}

// Get the results from the selected options
function getResults(event) {
	// Set the Options to Local Storage
	localStorage.options = JSON.stringify(OptionsJson.saveOptions());

	// Update set options
	setOptions(JSON.parse(localStorage.options));

	// remove selected products
	localStorage.removeItem('products');

	hideProducts();
	hideRelated();
	hideResults();
	showProducts();
	scrollToSections($el.productsForm, 50);

	event.preventDefault();

	matchHeights();
}

// Save the products from the selected options
function saveProducts(event) {
	// Set the Options to Local Storage
	localStorage.products = JSON.stringify(ProductsJson.saveProducts());

	// Update set options
	setProducts(JSON.parse(localStorage.products));

	showResults();

	event.preventDefault();
}

// Clear out all selected options
function clearResults() {
	// Hide products and results
	hideProducts();
	hideRelated();
	hideResults();
	// Hide all option groups apart from the first on initial load
	// $el.optionsGroup.not(':eq(0)').hide();
	// Reset forms
	// $el.optionsForm[0].reset();
	$el.productsForm[0].reset();
	// Empty local storage item
	localStorage.removeItem('options');
	localStorage.removeItem('products');
	// scroll back to top
	// scrollToSections($el.optionsForm);

	// event.preventDefault();

	setTimeout(() => {
		showStickyMessage();
	}, 5000);
}

function updateRange(event) {
	if (localStorage.getItem('options') != null) {
		edit();
		event.preventDefault();
	}
}

function edit() {
	editModal();
}

function editModal() {
	$.fancybox.open({
		src: '#edit-content',
	});
}

function editModalContinue() {
	// Set the option from selected option if it exists and isnt the range slider
	if (selectedOption.length && !selectedOption.hasClass('js-rangeslider')) {
		selectedOption.prop('checked', true);
	}
	$.fancybox.close();
	// Reset options
	clearResults();
}

function editModalCancel() {
	// Reset form to saved options
	OptionsJson.loadOptions(JSON.parse(localStorage.options));
	$el.optionRange.rangeslider('update', true);
	$.fancybox.close();
}

function editButton(event) {
	const $this = $(event.target);
	const scrollTo = $($this.attr('href'));
	scrollToSections(scrollTo);
	event.preventDefault();
}

// Hide the product container, option containers and products
function hideProducts() {
	$el.productsHolder.hide();
	$el.productOption.hide();
	$el.productOptionAltHolder.hide();
	$el.product.hide();
	$el.productOption.find($el.product).remove();
	$el.relatedOptionGroup.find($el.skipButton).show();
	$el.relatedOptionGroup.find($el.nextButton).hide();
}

// Show relevant products pased on selected options
function showProducts() {
	// Type = Combi
	if (selected.Type === 'Combi') {
		$el.products.LogicPlusCombi.appendTo($el.productOptions.one).show();
		$el.products.VogueCombi.appendTo($el.productOptions.two).show();
	}

	// Type = Heat
	if (selected.Type === 'Heat') {
		$el.products.LogicPlusHeat.appendTo($el.productOptions.one).show();
		$el.products.LogicPlusSystem.appendTo($el.productOptions.two).show();
	}
	if (selected.Type === 'Heat' &&
		selected.Bathrooms < 3
	) {
		$el.productOptionAltHolder.show();
		$el.products.LogicPlusCombi.appendTo($el.productOptions.three).show();
	} else if (
		selected.Type === 'Heat' &&
		selected.People >= 3 &&
		selected.Bathrooms >= 3
	) {
		$el.productOptionAltHolder.show();
		$el.products.VogueSystem.appendTo($el.productOptions.three).show();
	}

	// Type = System
	if (selected.Type === 'System') {
		$el.products.LogicPlusSystem.appendTo($el.productOptions.one).show();
		$el.products.VogueSystem.appendTo($el.productOptions.two).show();
	}
	if (selected.Type === 'System' &&
		selected.People <= 3 
	) {
		$el.productOptionAltHolder.show();
		$el.products.LogicPlusCombi.appendTo($el.productOptions.three).show();
	}
	if (selected.Type === 'System' &&
		selected.People >= 3 &&
		selected.Bathrooms < 3
	) {
		$el.productOptionAltHolder.show();
		$el.products.LogicPlusCombi.appendTo($el.productOptions.three).show();
	}

	// Type = Don't Know
	if (selected.Type === 'Dont-Know') {
		$el.products.LogicPlusCombi.appendTo($el.productOptions.one).show();
		$el.products.VogueCombi.appendTo($el.productOptions.two).show();
	}
	if (
		selected.Type === 'Dont-Know' &&
		selected.People >= 3 &&
		selected.Bathrooms >= 3
	) {
		$el.productOptionAltHolder.show();
		$el.products.LogicPlusHeat.appendTo($el.productOptions.three).show();
	}

	// Type = New Build
	if (
		selected.Type === 'New-Build' &&
		selected.People >= 3 &&
		selected.Bathrooms >= 3
	) {
		$el.products.LogicPlusHeat.appendTo($el.productOptions.one).show();
		$el.products.VogueSystem.appendTo($el.productOptions.two).show();
		
	} else if (
		selected.Type === 'New-Build'
	) {
		$el.products.LogicCombiEsp1.appendTo($el.productOptions.one).show();
		$el.products.VogueCombi.appendTo($el.productOptions.two).show();
	}
	if (
		selected.Type === 'New-Build' &&
		selected.People >= 3 &&
		selected.Bathrooms >= 3
	) {
		$el.productOptionAltHolder.show();
		$el.products.LogicCodeCombiEsp1
			.appendTo($el.productOptions.three)
			.show();
	}

	// Show products container
	if ($el.productsHolder.find($el.product).length > 0) {
		$el.productsHolder.show();
	}

	// Show options that have products
	if ($el.productOptions.one.find($el.product).length > 0) {
		$el.productOptions.one.show();
	}
	if ($el.productOptions.two.find($el.product).length > 0) {
		$el.productOptions.two.show();
	}
	if ($el.productOptions.three.find($el.product).length > 0) {
		$el.productOptionAltHolder.show();
		$el.productOptions.three.show();
	}

	// Show relevant related products
	$.each($el.relatedGroup, function() {
		const $this = $(this);
		if ($this.data('related') === productsSelected.Boiler) {
			$this.show();
		}
	});

	// Clear out old selected states
	$el.productsForm.find('input').each(function() {
		$(this).prop('checked', false);
	});

	$el.product.on('click', selectBoiler);
}

// Select Boiler
function selectBoiler() {
	const $this = $(this);
	const boiler = $this.data('boiler');

	// hide all related and show relevant products for selected boiler
	hideRelated();
	hideResults();
	showRelated(boiler);
}

// Hide the controls container and controls
function hideRelated() {
	$el.relatedGroup.hide();
	$el.relatedGroup.find('input').each(function() {
		$(this).prop('checked', false);
	});
}

// Show the cotrols for the selected boiler
function showRelated(boiler) {
	$.each($el.relatedGroup, function() {
		const $this = $(this);
		if ($this.data('related') === boiler) {
			$this.show();
			$this.find($el.relatedOptionGroup).not(':eq(0)').hide();
			scrollToSections($this);
		}
	});
}

// Show next related products
function nextRelated(event) {
	const next = $(this)
		.closest($el.relatedOptionGroup)
		.next($el.relatedOptionGroup);
	// Show the next set of options
	if (next.length) {
		next.show();
		scrollToSections(next);
	}
	event.preventDefault();
}

// Need to show next or skip button if this groop has any checked
function nextSkip() {
	$.each($el.relatedOptionGroup, function() {
		$(this).find('input').on('change', function() {
			if (
				$(this)
					.closest($el.relatedOptionGroup)
					.find('input')
					.is(':checked')
			) {
				$(this)
					.closest($el.relatedOptionGroup)
					.find($el.nextButton)
					.show();
				$(this)
					.closest($el.relatedOptionGroup)
					.find($el.skipButton)
					.hide();
			} else {
				$(this)
					.closest($el.relatedOptionGroup)
					.find($el.skipButton)
					.show();
				$(this)
					.closest($el.relatedOptionGroup)
					.find($el.nextButton)
					.hide();
			}
		});
	});
}

function hideResults() {
	// Hide results and empty out table
	$el.results.hide();
	$el.resultsHolder.empty();
}

// Show results
function showResults() {
	hideStickyMessage();
	// Remove any old results
	$el.resultsHolder.empty();
	// Show resulst and scroll to them
	setTimeout(() => {
		$el.results.show(function() {
			$(this).addClass('is-open');
		});
		scrollToSections($el.results, 0);
	}, 300);

	// Retrieve the template data from the HTML (jQuery is used here).
	const template = $('#results').html();
	// Compile the template data into a function
	const templateScript = Handlebars.compile(template);
	// Get results data from local storage
	const context = _.merge(
		JSON.parse(localStorage.options),
		JSON.parse(localStorage.products),
	);
	// html
	const html = templateScript(context);
	// Append to page
	$el.resultsHolder.append(html);

	setTimeout(() => {
		tableWrapper();
	}, 1000);
}

function scrollToSections(section, negativeOffset = 100) {
	const scrollOffset = section.offset().top - negativeOffset;
	setTimeout(() => {
		TweenMax.to(window, 1.1, {
			scrollTo: {
				y: scrollOffset,
				autoKill: true, // allows user to kill scroll action smoothly
			},
			ease: Expo.easeInOut,
		});
	}, 400);
}

// Options
// Save Selected Options
OptionsJson.saveOptions = function() {
	const selectedOptions = $el.optionsForm.serializeJSON();
	return selectedOptions;
};
// Load Selected Options
OptionsJson.loadOptions = function(selectedOptions) {
	$el.optionsForm.find('input').each(function() {
		const $this = $(this);
		const val = _.get(selectedOptions, $this.attr('name'));
		if ($this.is('[type=radio], [type=checkbox]')) {
			if ($this.val() === val) {
				$this.prop('checked', true);
			}
		} else {
			$this.val(val);
		}
	});
};

// Products
// Save selected products
ProductsJson.saveProducts = function() {
	const selectedProducts = $el.productsForm.serializeJSON();
	return selectedProducts;
};

function rangeSlider() {
	const valueBubble = '<output class="rangeslider__value-bubble" />';
	function updateValueBubble(pos, value, context) {
		pos = pos || context.position;
		value = value || context.value;
		const $valueBubble = $('.rangeslider__value-bubble', context.$range);
		const position = pos + context.grabPos;
		if ($valueBubble.length) {
			$valueBubble[0].style.left = `${Math.ceil(position)}px`;
			$valueBubble[0].innerHTML = value;
		}
	}
	$el.optionRange.rangeslider({
		polyfill: false,
		onInit() {
			this.$range.append($(valueBubble));
			updateValueBubble(null, null, this);
		},
		onSlide(pos, value) {
			updateValueBubble(pos, value, this);
		},
	});
}

// Needs re-firing when things are shown
function matchHeights() {
	$('.js-match-height').matchHeight();
}
